export default __webpack_public_path__ + "static/media/164.37697ba7.svg";